// ─────────────────────────────────────────────────────────────
// CENTRAL SITE CONTENT — edit everything about the studio here.
// ─────────────────────────────────────────────────────────────

export const studio = {
  name: "tutinsapp",
  displayName: "tutinsapp",
  legalName: "tutinsapp", // ← replace with your registered legal entity name
  domain: "tutinsapp.online",
  tagline: "We build small mobile apps that respect the people using them.",
  intro:
    "tutinsapp is an independent mobile app studio. We design and ship focused iOS and Android apps — starting with education-first tools for health and everyday wellbeing.",
  // Studio fallback address. Per-app support addresses live in src/data/apps.js
  // (AuraHealth uses aurahealth@tutinsapp.live for its customer service).
  supportEmail: "aurahealth@tutinsapp.live",
  location: "Remote studio",
  foundedYear: "2026",
  marquee: [
    "independent studio",
    "education first",
    "privacy by default",
    "iOS + Android",
    "no dark patterns",
    "built in the open",
  ],
  manifesto: [
    {
      no: "01",
      title: "Education before advice",
      body: "Our apps explain, they don't prescribe. We write plain-language content, cite where it comes from, and never dress information up as a diagnosis.",
    },
    {
      no: "02",
      title: "Your data stays yours",
      body: "We ask for the minimum we need to make a feature work. We do not sell personal data. What we collect and why is written out in the privacy policy — not buried.",
    },
    {
      no: "03",
      title: "Small, finished, maintained",
      body: "One app at a time, shipped properly and kept alive. Support is answered by the people who wrote the code, not a queue.",
    },
  ],
};

// Reusable disclaimer copy — edit freely.
export const disclaimers = {
  health:
    "Information provided by this application is for educational and informational purposes only and is not intended to diagnose, treat, cure, or prevent any disease or medical condition. This application does not replace professional medical advice. Consult a qualified healthcare professional for medical concerns.",
  general:
    "Features and availability may change as the app is developed. Nothing on this page is a guarantee of a specific outcome.",
};

// Sources / references. Add entries as you confirm them.
// Leave `url` empty to render as “link pending”.
export const sources = [
  {
    id: "src-who",
    organization: "World Health Organization (WHO)",
    title: "Placeholder — exact publication to be added",
    description:
      "Intended to support general women's health and reproductive health background information.",
    url: "",
    apps: ["aurahealth"],
  },
  {
    id: "src-nih",
    organization: "National Institutes of Health (NIH)",
    title: "Placeholder — exact publication to be added",
    description:
      "Intended to support hormone and menstrual cycle physiology explanations.",
    url: "",
    apps: ["aurahealth"],
  },
  {
    id: "src-acog",
    organization:
      "American College of Obstetricians and Gynecologists (ACOG)",
    title: "Placeholder — exact publication to be added",
    description:
      "Intended to support cycle-tracking and common symptom education content.",
    url: "",
    apps: ["aurahealth"],
  },
  {
    id: "src-placeholder-04",
    organization: "Additional reputable health organisation",
    title: "Placeholder — to be replaced",
    description:
      "Reserved slot. Replace organisation, title, description and link once confirmed.",
    url: "",
    apps: ["aurahealth"],
  },
];

export const faqs = [
  {
    appId: "all",
    q: "How do I contact support?",
    a: "Use the form on this page — pick the app you need help with first. Each app also has its own support address shown on its page; AuraHealth customer service is aurahealth@tutinsapp.live. We aim to reply within 2–3 business days.",
  },
  {
    appId: "all",
    q: "How do I request deletion of my data?",
    a: "Send us a request from the email address linked to your account, or use the form on this page and choose “Privacy & data”. We will confirm once the request is completed.",
  },
  {
    appId: "all",
    q: "How do I cancel a subscription?",
    a: "Subscriptions are billed by Apple or Google, so they are cancelled in your device account settings — App Store subscriptions on iOS, Google Play subscriptions on Android. We cannot cancel them on your behalf.",
  },
  {
    appId: "aurahealth",
    q: "Does AuraHealth give medical advice?",
    a: "No. AuraHealth is educational and informational only. It does not diagnose, treat or prevent any condition. Please speak to a qualified healthcare professional about medical concerns.",
  },
  {
    appId: "aurahealth",
    q: "Where does the educational content come from?",
    a: "Reference organisations and publications are listed on our Sources page. Entries are added as they are confirmed — we do not cite anything we have not used.",
  },
  {
    appId: "aurahealth",
    q: "What is the PMOS Risk Chat, and is it a diagnosis?",
    a: "It is an educational conversation with Luna that helps you reflect on symptoms and decide whether it is worth raising with a doctor. It is not a screening test, not a diagnosis, and not a medical assessment. Only a qualified healthcare professional can diagnose a condition.",
  },
  {
    appId: "aurahealth",
    q: "Who is Luna?",
    a: "Luna is the in-app companion that answers questions about the educational content, nudges you about habits you have not logged, and can be used by voice or by chat. Luna does not give medical advice.",
  },
  {
    appId: "aurahealth",
    q: "What is in the Doctor Report?",
    a: "A PDF summary of what you logged — cycle dates, symptoms, habits and trends — that you can save or share with your gynaecologist. It is your own data, formatted to be easy to read. Nothing is sent anywhere automatically.",
  },
  {
    appId: "aurahealth",
    q: "Should I take the supplements listed in the app?",
    a: "The supplements section is educational reference material only. Do not start, stop or change any supplement based on the app — talk to a qualified healthcare professional first, especially if you take medication or are pregnant.",
  },
  {
    appId: "aurahealth",
    q: "Can I use the app without a premium subscription?",
    a: "Yes. Core cycle and symptom logging, the daily habit tracker and your streak are free. Premium unlocks the full education library, deeper progress views and the Doctor Report export.",
  },
  {
    appId: "next-app",
    q: "When will the next app be released?",
    a: "It is still in development and has no confirmed release date. There are no store links yet — this page will be updated when there is something real to announce.",
  },
];

export const supportTopics = [
  { value: "question", label: "General question" },
  { value: "problem", label: "Report a problem" },
  { value: "account", label: "Account help" },
  { value: "billing", label: "Billing & subscriptions" },
  { value: "privacy", label: "Privacy & data" },
  { value: "feedback", label: "Feature request / feedback" },
  { value: "other", label: "Something else" },
];
